import React from 'react'

export default function InputDataTableView(props) {
  const { schema } = props
  // const col = props.column ? props.column : 1

  return (
    <div>
      <ul>
        {schema.value && schema.value.length > 0 ? (
          schema.value.map((item, index) => {
            return (
              // <li>
              //   {/* {index + 1}. */}
              //   {item.value}
              // </li>
              <li dangerouslySetInnerHTML={{ __html: item.value }} />
            )
          })
        ) : (
          <span>- ไม่ได้ระบุ -</span>
        )}
      </ul>
    </div>
  )
}
